import {
  Country,
  Disaster,
  DisasterSpecificSurveyInput,
  DocumentInfo,
  FileUploadResponse,
  LocationSpecificSurveyInput,
  Message,
  NewsFeed,
  Donation,
  Organization,
  RecentSurveyResponse,
  Service,
  SearchResult,
  ScoreDto,
  Twitter,
  User,
  UserApprove,
  UserLoginHistory,
} from '.';
import { DisasterAndContacts } from '../dashboard/servicesComponets/surveys/disasterSpecificTable/disaster-specific-table.model';
import { GeneralOrganizationBackgroundSurveyInput } from '../dashboard/servicesComponets/surveys/generalOrganizationBackground/general-organization-background.model';
import { StripeDonation } from './StripeDonation';

export interface SRResponse extends SRBaseResponse {
  responseData: ResponseData;
}

export interface SRBaseResponse {
  responseData: any;
  errors: any[];
  status: number;
  statusMessage: string;
}

export interface ResponseData {
  country?: Country;
  country_list?: Country[];
  disaster?: Disaster;
  disaster_by_location?: Disaster[];
  disaster_list?: Disaster[];
  disaster_logo?: FileUploadResponse;
  disaster_type_list?: Disaster[];
  disaster_org_list?: DisasterAndContacts[];
  dss_table_list?: DisasterSpecificSurveyInput[];
  doc?: DocumentInfo;
  msg_list?: Message[];
  organization_logo?: FileUploadResponse;
  organization?: Organization;
  org_list?: Organization[];
  service_provided?: Service[];
  count?: number;
  metadata?: string;
  service?: Service;
  service_list?: Service[];

  survey?: LocationSpecificSurveyInput;
  lss_table_list?: LocationSpecificSurveyInput[];
  donations?: Donation[];
  stripeDonation?: StripeDonation[];
  users?: User[];
  user?: User;
  userLoginHistory?: UserLoginHistory[];
  usersApprovallist?: UserApprove[];

  survey_list?: RecentSurveyResponse[];
  search_result_list?: SearchResult[];
  token?: string;
  profile?: User;

  tweet_list?: Twitter[];
  news_item_list?: NewsFeed[];
}

export interface ScoreResponseData {
  lss_table_list?: ScoreDto[];
}

export interface DisasterResponseData {
  survey?: DisasterSpecificSurveyInput;
}

export interface ScoreSRResponse extends SRBaseResponse {
  responseData: ScoreResponseData;
}

export interface DisasterSRResponse extends SRBaseResponse {
  responseData: DisasterResponseData;
}

export interface ResponseField<T> {
  value: T;
  [name: string]: any;
}
